import { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import publicAPI from '../../publicApi';
import AppPrompt from '../../components/AppPrompt';
import './PublicPage.css';

/**
 * 공개 공지사항 페이지
 * URL: /:tenantId/notice/:id?token=xxx
 */
export default function PublicNotice() {
  const { tenantId, id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadNotice = useCallback(async () => {
    if (!token) {
      setError('유효하지 않은 링크입니다');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const { data } = await publicAPI.getNotice(tenantId, id, token);
      setNotice(data);
      setError(null);
    } catch (err) {
      console.error('Failed to load notice:', err);
      setError(err.response?.data?.error || '공지사항을 불러오는데 실패했습니다');
    } finally {
      setLoading(false);
    }
  }, [tenantId, id, token]);

  useEffect(() => {
    loadNotice();
  }, [loadNotice]);

  if (loading) {
    return (
      <div className="public-page">
        <div className="public-container">
          <div className="loading-spinner">로딩 중...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="public-page">
        <div className="public-container">
          <div className="error-message">
            <h3>⚠️ 오류</h3>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!notice) {
    return (
      <div className="public-page">
        <div className="public-container">
          <div className="error-message">
            <h3>📢 공지사항을 찾을 수 없습니다</h3>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="public-page">
      <AppPrompt />
      <div className="public-container">
        <div className="public-header">
          <div className="header-badge">공지사항</div>
          <h1 className="public-title">{notice.title}</h1>
          <div className="public-meta">
            <span className="meta-item">📅 {notice.date}</span>
          </div>
        </div>

        <div className="public-section">
          <div className="section-content">
            {notice.content || notice.message}
          </div>
        </div>

        <div className="public-footer">
          <p className="footer-text">EduStaff 학원관리 시스템</p>
        </div>
      </div>
    </div>
  );
}
